import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import heroImage from "@/assets/hero-home.jpg";
import { trackBookClick } from "@/utils/analytics";

// Preload hero image as early as possible for LCP
if (typeof document !== "undefined") {
  const existing = document.querySelector('link[data-hero-preload]');
  if (!existing) {
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = heroImage;
    link.setAttribute("data-hero-preload", "true");
    document.head.appendChild(link);
  }
}

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Stunning luxury property photographed by Luminate Media"
          className="w-full h-full object-cover"
          fetchPriority="high"
        />
        <div className="absolute inset-0 bg-gradient-overlay" />
        <div className="absolute inset-0 bg-background/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <p 
            className="text-primary font-medium tracking-[0.3em] uppercase text-sm mb-6 animate-fade-up opacity-0" 
            style={{ animationDelay: "0.2s", animationFillMode: "forwards" }}
          >
            Premium Real Estate Media
          </p>
          <h1 
            className="font-serif text-4xl md:text-6xl lg:text-7xl font-semibold text-foreground mb-6 leading-tight animate-fade-up opacity-0" 
            style={{ animationDelay: "0.4s", animationFillMode: "forwards" }}
          >
            High-Impact <span className="whitespace-nowrap">Real Estate</span>
            <br />
            <span className="text-gradient-gold">Photography & Video</span>
          </h1>
          <p 
            className="text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl mx-auto animate-fade-up opacity-0" 
            style={{ animationDelay: "0.6s", animationFillMode: "forwards" }}
          >
            Serving real estate professionals across Washington and Arkansas with 
            cinematic visuals that help listings stand out and sell faster.
          </p>
          <div 
            className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-up opacity-0" 
            style={{ animationDelay: "0.8s", animationFillMode: "forwards" }}
          >
            <Button variant="hero" size="xl" asChild>
              <Link to="/book" onClick={() => trackBookClick("hero")}>Book a Shoot</Link>
            </Button>
            <Button variant="heroOutline" size="xl" asChild>
              <Link to="/portfolio">View Our Work</Link>
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <a href="#services" className="text-primary">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 5v14M19 12l-7 7-7-7"/>
          </svg>
        </a>
      </div>
    </section>
  );
};

export default HeroSection;
